<app-oee-modal
    title="Check Time Entry"
    subtitle="We noticed something that may be unintended."
    icon="warning"
    [useMaterialIcon]="true"
    iconColor="yellow"
    tint="amber"
    size="sm"
    (closeClick)="onCancel()">

    <ng-container modal-content>
        <div class="sanity-warnings">
            @if (data.spansMultipleDays) {
                <div class="warning-block">
                    <div class="warning-title">
                        <i class="fa-solid fa-calendar-days text-warning me-2"></i>
                        Spans multiple days
                    </div>
                    <div class="warning-body">
                        This entry starts on <strong>{{ startDateDisplay }}</strong>
                        and ends on <strong>{{ endDateDisplay }}</strong>
                        ({{ durationLabel }} total). Double-check the start and end times before continuing.
                    </div>
                </div>
            }

            @if (data.unusualStation) {
                <div class="warning-block">
                    <div class="warning-title">
                        <i class="fa-solid fa-location-dot text-warning me-2"></i>
                        Unusual station
                    </div>
                    <div class="warning-body">
                        You haven't worked at
                        <strong>{{ data.unusualStation.stationName || 'this station' }}</strong>
                        before in your recent history. Double-check you picked the right station.
                    </div>
                </div>
            }

            @if (data.stationOffProcessFlow) {
                <div class="warning-block">
                    <div class="warning-title">
                        <i class="fa-solid fa-diagram-project text-warning me-2"></i>
                        Not in process flow
                    </div>
                    <div class="warning-body">
                        <strong>{{ data.stationOffProcessFlow.fromStationName || 'The job\'s last station' }}</strong>
                        &rarr;
                        <strong>{{ data.stationOffProcessFlow.stationName || 'this station' }}</strong>
                        is not in the process flow for
                        @if (data.stationOffProcessFlow.productName) {
                            <strong>{{ data.stationOffProcessFlow.productName }}</strong>.
                        } @else {
                            this product.
                        }
                        Double-check the station before continuing.
                    </div>
                </div>
            }

            @if (data.jobActiveAtOtherStations.length > 0) {
                <div class="warning-block">
                    <div class="warning-title">
                        <i class="fa-solid fa-circle-play text-warning me-2"></i>
                        Job already active elsewhere
                    </div>
                    <div class="warning-body">
                        This job is already running at
                        @for (active of data.jobActiveAtOtherStations; track active.stationId; let last = $last) {
                            <strong>{{ active.stationName || 'another station' }}</strong>{{ last ? '' : ', ' }}
                        }.
                        Continuing will start another active instance of the job.
                    </div>
                </div>
            }

            <p class="confirm-prompt">Do you want to continue anyway?</p>
        </div>
    </ng-container>

    <ng-container modal-actions>
        <button mat-button (click)="onCancel()">Cancel</button>
        <button mat-raised-button color="warn" (click)="onContinue()">{{ continueLabel }}</button>
    </ng-container>
</app-oee-modal>
